// All or portions of this file Copyright © 2019 Amazon Web Services, Inc. or its affiliates or licensors.
// All rights reserved. For full license terms and conditions, please see the LICENSE file at the root of
// this distribution (the "License") or go to https://content.sumerian.amazonaws.com/engine/latest/license.txt.
// All use of the software is governed by the License. All materials are made available on an "AS IS" BASIS, WITHOUT
// WARRANTIES OR CONDITIONS OF ANY KIND, express or implied. Do not remove or modify any license notices.
import ComponentHandler from 'core/loaders/handlers/ComponentHandler';
import DialogueComponent from './DialogueComponent';

/**
 * The handler for the dialogue component.
 */
class DialogueComponentHandler extends ComponentHandler {
  constructor(...args) {
    super(...args);
    this._type = 'DialogueComponent';
  }

  /**
   * Creates a DialogueComponent.
   * @returns {DialogueComponent}
   */
  _create() {
    return new DialogueComponent();
  }

  /**
   * Update engine dialogue component based on the config.
   * @param {Entity} entity The entity on which this component should be added.
   * @param {Object} config
   * @param {Object} options
   * @returns {Promise} Promise that resolves with the component when
   * loading is done.
   */
  update(entity, config, options) {
    return ComponentHandler.prototype.update.call(this, entity, config, options)
      .then(component => {
        if (component) {
          component.updateConfig(config);
          return Promise.resolve(component);
        }
      });
  }
}

ComponentHandler._registerClass('dialogue', DialogueComponentHandler);

export default DialogueComponentHandler;
